var theme = require('./theme')
var flatten = require('./flatten')

module.exports = theme('de_DE', flatten(require('./source/de_DE')))
